$(document).ready(function() {
  $('.get-help').tooltip({ followPointer: true });
  $('.stay-strong').tooltip({ followPointer: true });
  $('.book-physio').tooltip({ followPointer: true });
});
